export const ERROR_TYPES = {
  SPREADING_FAILED: 'SPREADING_FAILED',
  MAPPING_FAILED: 'MAPPING_FAILED',
  EMPTY_EVENT: 'EMPTY_EVENT',
  FILTERED: 'FILTERED',
  EXPRESSION_FAILED: 'EXPRESSION_FAILED',
  ENRICHMENT_FAILED: 'ENRICHMENT_FAILED',
  INVALID_LUA: 'INVALID_LUA',
  UNDECLARED_VARIABLE: 'UNDECLARED_VARIABLE',
  UNCATEGORIZED: 'UNCATEGORIZED',
};

const ERROR_PREFIX_TO_ERROR_TYPE = {
  'spreading failed': ERROR_TYPES.SPREADING_FAILED,
  'mapping failed': ERROR_TYPES.MAPPING_FAILED,
  'empty event': ERROR_TYPES.EMPTY_EVENT,
  'did not pass filter condition': ERROR_TYPES.FILTERED,
  'expression failed': ERROR_TYPES.EXPRESSION_FAILED,
  'enrichment failed': ERROR_TYPES.ENRICHMENT_FAILED,
  'invalid lua': ERROR_TYPES.INVALID_LUA,
};

function splittableErrorMessage(errorMessage) {
  return errorMessage.includes(':');
}

function splitErrorMessage(errorMessage) {
  const [prefix, ...rest] = errorMessage.split(':');
  const message = rest.join(':') || null;
  return {
    prefix,
    message,
  };
}

function buildError(errorMessage) {
  if (splittableErrorMessage(errorMessage)) {
    return handleSplittableError(errorMessage);
  }
  return handleOtherErrors(errorMessage);
}

function handleSplittableError(errorMessage) {
  const { prefix, message } = splitErrorMessage(errorMessage);
  const type = ERROR_PREFIX_TO_ERROR_TYPE[prefix];

  if (type) {
    return { type, message };
  }

  return uncategorizedError(errorMessage);
}

function handleOtherErrors(errorMessage) {
  if (errorMessage.startsWith('empty event')) {
    return {
      type: ERROR_TYPES.EMPTY_EVENT,
      message: null,
    };
  }

  if (errorMessage.startsWith('undeclared variable')) {
    const result = errorMessage.match(/undeclared variable (.*) found/);
    if (result && result[0]) {
      const message = result[0].trim();
      return {
        type: ERROR_TYPES.UNDECLARED_VARIABLE,
        message,
      };
    }
  }
  return uncategorizedError(errorMessage);
}

function uncategorizedError(errorMessage) {
  return {
    type: ERROR_TYPES.UNCATEGORIZED,
    message: errorMessage,
  };
}

export default function transformErrors(errors) {
  return errors.map(error => buildError(error.message));
}
